<p-button
  [label]="label()"
  [loading]="loading()"
  [disabled]="disabled() || loading()"
  [severity]="severity()"
  [size]="size() === 'small' ? 'small' : undefined"
  (onClick)="onClick()">
</p-button>
